import React from 'react';
import styled from 'styled-components';
import { Form as BootstrapForm } from 'react-bootstrap';

import { SIDEBAR_DELAY } from '@/config/variables';

interface IToggleSwitch {
  name: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  checked?: boolean;
  disabled?: boolean;
  label?: string;
}

const ToggleSwitch = (props: IToggleSwitch): React.ReactElement => {
  const { name, ...rest } = props;
  return <StyledSwitch type="switch" id={name} {...rest} />;
};

export { ToggleSwitch };

const StyledSwitch = styled(BootstrapForm.Check)`
  margin-right: -8px;
  transition: margin-right ${SIDEBAR_DELAY}ms;
  cursor: pointer;

  .custom-control-label {
    &::before,
    &::after {
      cursor: pointer;
    }
  }

  .collapsed & {
    margin-right: -4px;
  }

  &:disabled {
    background: #adb5bd;
    color: #ffffff;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);
    border-color: transparent;
  }
`;
